import { canReadStaffCustomerDirectory } from "./staffCustomerAccess";

export const CUSTOMER_SEARCH_FULL_ACCESS_ROLES = ["admin", "finance", "service"] as const;

export type CustomerSearchAccess = "full";

export type CustomerSearchSourceHit = {
  id: number;
  name: string;
  contact?: string | null;
  email?: string | null;
  address?: string | null;
  unitNumber?: string | null;
  postalCode?: string | null;
  formattedAddress?: string | null;
  matchedAlias?: string | null;
  createdAt?: Date | string | null;
  createdByUserId?: number | null;
  createdByUserName?: string | null;
  creationSource?: string | null;
  salespersonId?: number | null;
  salespersonName?: string | null;
  rankTier?: number;
  /** Internal test customer (customers.isTest). Shown with a grey "Test" badge; never hidden. */
  isTest?: boolean | null;
};

export type CustomerSearchFullHit = CustomerSearchSourceHit & {
  access: "full";
  id: number;
  name: string;
};

export type CustomerSearchHit = CustomerSearchFullHit;

export function isFullCustomerSearchHit(hit: CustomerSearchHit): hit is CustomerSearchFullHit {
  return hit.access === "full";
}

export function fullCustomerSearchHits(hits: CustomerSearchHit[] | undefined | null): CustomerSearchFullHit[] {
  return (hits ?? []).filter(isFullCustomerSearchHit);
}

export function toFullCustomerSearchHit(hit: CustomerSearchSourceHit): CustomerSearchFullHit {
  return { ...hit, access: "full" };
}

/**
 * Directory search presentation: every visible canonical hit for authenticated staff.
 * Never filters solely because salespersonId !== user.id.
 */
export function presentCustomerSearchHits(args: {
  role: string;
  userId: number;
  hits: CustomerSearchSourceHit[];
}): CustomerSearchHit[] {
  if (!canReadStaffCustomerDirectory(args.role)) return [];
  return args.hits.map(toFullCustomerSearchHit);
}
